// extracted by mini-css-extract-plugin
export default {"rating":"QI-z","numberOfStars":"RI-z","count":"SI-z","barGraphSpacing":"TI-z","barGraph":"UI-z"};